import { render, staticRenderFns } from "./courseListingForCoursework.vue?vue&type=template&id=11a4943b&"
import script from "./courseListingForCoursework.vue?vue&type=script&lang=js&"
export * from "./courseListingForCoursework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports